import { useParams, Navigate } from "react-router-dom";
import { getPlanning } from "@/data/planning";
import { PageHero } from "@/components/common/PageHero";
import { Reveal } from "@/components/common/Reveal";
import { SectionRenderer } from "@/components/blocks/SectionRenderer";
import { RelatedTickets } from "@/components/cards/RelatedTickets";
import { RelatedLinks } from "@/components/cards/RelatedLinks";
import { CTASection } from "@/components/common/CTASection";
import { BookButton } from "@/components/common/BookButton";

export default function PlanDetail() {
  const { slug } = useParams();
  const page = getPlanning(slug);
  if (!page) return <Navigate to="/plan" replace />;

  return (
    <>
      <PageHero
        overline="Plan Your Visit"
        title={page.title}
        subtitle={page.subtitle}
        image={page.heroImage}
        breadcrumbs={[{ label: "Plan Your Visit", to: "/plan" }, { label: page.title }]}
      />

      <div className="container-wide py-14 md:py-20">
        <div className="grid gap-12 lg:grid-cols-[1fr_320px]">
          <div>
            <Reveal>
              <p className="max-w-3xl border-l-2 border-gold pl-6 font-serif text-xl md:text-2xl font-light leading-relaxed text-charcoal text-balance">
                {page.intro}
              </p>
            </Reveal>
            <div className="mt-14 md:mt-16">
              <SectionRenderer blocks={page.blocks} />
            </div>
          </div>

          <aside className="lg:relative">
            <div className="space-y-8 lg:sticky lg:top-24">
              <div className="rounded-2xl border border-stone-line bg-charcoal p-6 text-white">
                <h3 className="font-serif text-xl font-medium">Ready to book?</h3>
                <p className="mt-2 text-sm font-light text-white/70">
                  Skip the queues and lock in your time slot through our trusted partner.
                </p>
                <BookButton label="Browse tickets" className="mt-5 w-full" testId="plan-sidebar-book" />
              </div>
              <RelatedLinks title="More planning guides" links={page.relatedPlanning} testId="plan-related-links" />
            </div>
          </aside>
        </div>
      </div>

      <RelatedTickets
        slugs={page.relatedTickets}
        overline="Book your visit"
        title="Recommended tickets"
        description="Now that you know the details, choose the ticket that fits your plans."
      />

      <div className="container-wide pb-20">
        <CTASection />
      </div>
    </>
  );
}
